import axios from 'axios'
import { Indicator,Toast } from 'mint-ui'
import queryString from 'queryString'

const $http = axios.create({
  baseURL: 'https://gmat.thinkwithu.com',
  // baseURL: 'http://thinkugmat.cc',
  responseType: 'json',
  timeout: 10000,
  // withCredentials: true
})
/**
 * 请求拦截
 */
$http.interceptors.request.use(config => {
  Indicator.open({
    spinnerType: 'fading-circle'
  })
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  config.data = queryString.stringify(config.data)
  // config.crossDomain = true;
  return config
},err => {
  Indicator.close()
  Toast("请求超时!");
  return Promise.resolve(err);
})

/**
 * 响应拦截
 */
$http.interceptors.response.use(resp => {
  Indicator.close();
  return resp
},err => {
  Toast("请求超时，请重试！");
  Indicator.close()
  if (err.response.status == 504 || response.status == 404) {
    Toast("服务器被吃了⊙﹏⊙∥")
  } else if(err.response.status == 403){
    Toast("请求超时，请重试！")
  } else {
    Toast("请求超时，请重试！");
  }
  return Promise.resolve(err)
})
export default $http



// WEBPACK FOOTER //
// ./src/requests/index.js